import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import PurchaseOrderList from './PurchaseList'

const PurchaseOrderInfos = ({ purchaseOrders }) => {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Supplier</TableCell>
                        <TableCell>Order No</TableCell>
                        <TableCell>Invoice No</TableCell>
                        <TableCell>PO No</TableCell>
                        <TableCell>Order Qty</TableCell>
                        {/* <TableCell>Shipped Qty</TableCell>
                        <TableCell>Received Qty</TableCell> */}
                        <TableCell style={{ width: '50px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {purchaseOrders?.map((purchaseOrder) => (
                        <PurchaseOrderList
                            purchaseOrder={purchaseOrder}
                            key={purchaseOrder.id}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default PurchaseOrderInfos
